function VasTagIcon() {
  return (
    <svg
      width="140"
      height="37"
      viewBox="0 0 140 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.3776 37H139.886V11.6371C139.886 7.45968 135.632 0.0524723 124.329 0L7.34886 0.298387L13.52 9L13.6973 9.25L33.3776 37Z"
        fill="url(#paint0_linear_7612_49565)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9C3.29794 1.81271 6.26677 0.200055 7.34886 0.298387L13.52 9H0Z"
        fill="#462844"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7612_49565"
          x1="7.34892"
          y1="18.5"
          x2="139.886"
          y2="18.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBF5A7" />
          <stop offset="1" stopColor="#FDF1E5" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default VasTagIcon;
